import React from 'react'
import { Form, Col, InputGroup, Row } from 'react-bootstrap'
import Checkbox from '../../../../components/component-items/checkbox'
import { HoverNotes } from '../../../../components/component-items/hover-notes'
import { WarehouseFieldsProps } from '../types'

export const TransportationManagementFields = ({ settings, setSettings, context }: WarehouseFieldsProps) => {
  const showField = (field: string) => {
    if (context === 'warehouse') return true
    return ['maxShippingAmount'].includes(field)
  }

  return (
    <Row style={{ marginTop: '.8em', marginBottom: '2em' }}>
      {showField('maxShippingAmount') && (
        <Form.Group as={Col} md="6" controlId="maxShippingAmount">
          <Form.Label>
            <HoverNotes
              description="Requires confirmation if shipping exceeds this limit"
              title="Max Shipping Amount"
            />
          </Form.Label>
          <Form.Control
            type="number"
            required
            value={settings.maxShippingAmount ?? ''}
            onChange={(e) =>
              setSettings({ ...settings, maxShippingAmount: e.target.value === '' ? null : e.target.value })
            }
          />
        </Form.Group>
      )}

      {showField('maxDeliveryDays') && (
        <Form.Group as={Col} md="6" controlId="maxDeliveryDays">
          <Form.Label>
            <HoverNotes
              description="Filters service levels where the delivery time exceeds this value"
              title="Max Delivery Days"
            />
          </Form.Label>
          <Form.Control
            type="number"
            value={settings.maxDeliveryDays ?? ''}
            onChange={(e) =>
              setSettings({ ...settings, maxDeliveryDays: e.target.value === '' ? null : e.target.value })
            }
          />
        </Form.Group>
      )}

      {showField('usePassport') && (
        <Col md="12">
          <InputGroup>
            <Checkbox
              selected={settings.usePassport}
              setSelected={() => setSettings({ ...settings, usePassport: !settings.usePassport })}
            />
            <p style={{ padding: '0 1em' }}>Enable Passport for Shipping</p>
          </InputGroup>
        </Col>
      )}
    </Row>
  )
}
